module.exports = __webpack_public_path__ + "static/media/imgplaceholder.17515945.svg";